import { lazy } from "react";



const MachineMangement = lazy(() => import("../../../../Pages/machineMangement/MachineMangement"));
const MachineStatus = lazy(() => import("../../../Common/Card/MachineStatus"));
const ShowSetup = lazy(() => import("../../../../Pages/AccessControl/ShowSetup"));
const AccessControl = lazy(() => import("../../../../Pages/AccessControl/AccessControl"))
export const MachineRoute = [
    { path: "monitor", element: <MachineMangement /> },
    { path: "accessMonitor", element: <AccessControl /> },
    { path: "machineStatus", element: <MachineStatus /> },
    { path: "setupMonitor", element: <ShowSetup /> }
];
